import { useEffect, useState } from 'react'
import { useWeb3React } from '@web3-react/core'
import {
  BaseProvider,
  Web3Provider,
} from '@ethersproject/providers'
import { getRpcProvider } from 'utils/providers'
// eslint-disable-next-line import/no-unresolved
import { Web3ReactContextInterface } from '@web3-react/core/dist/types'
import { CHAIN_ID } from 'config/constants/networks'

type ActiveProvider = Web3Provider | BaseProvider

/**
 * Uses the connected wallet provider when available.
 * Otherwise uses an RPC provider matching the active chain.
 */
const useActiveWeb3React =
  (): Web3ReactContextInterface<Web3Provider> => {
    const {
      library,
      chainId,
      ...web3React
    } = useWeb3React<Web3Provider>()

    const effectiveChainId =
      chainId ?? parseInt(CHAIN_ID, 10)

    const [provider, setProvider] =
      useState<ActiveProvider>(
        () => library || getRpcProvider(effectiveChainId),
      )

    useEffect(() => {
      setProvider(
        library || getRpcProvider(effectiveChainId),
      )
    }, [library, effectiveChainId])

    return {
      library: provider as Web3Provider,
      chainId: effectiveChainId,
      ...web3React,
    }
  }

export default useActiveWeb3React
